import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { Button, Label } from "reactstrap";
import "./reimbursementPolicy.css";
import CustomReactSelect from "../../../components/CustomReactSelect";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import FilterationBarContainer from "../../../components/FilterationBarContainer";
import { TableDateFormat } from "../../Dashboard/DashboardVariables";

const ReimbursementPolicyForm = (props) => {
	return (
		<>
			<FilterationBarContainer>
				<Col lg={6}>
					<Form.Group className="input-field">
						<Form.Label className="label">
							Select Designation
						</Form.Label>
						<Col>
							<CustomReactSelect
								className="dropDown"
								options={props.designationList}
								onChange={(obj) => props.getObject(obj)}
							/>
						</Col>
					</Form.Group>
				</Col>
			</FilterationBarContainer>

			<Form className="alterReimbursementLimitForm">
				<Label className="reimbursementLimitFormLabel">
					Alter Reimbursements Limits
				</Label>
				<Row className="row1">
					<Col>
						<Form.Group className="reimbursementPolicydropDown">
							<Form.Label>Medical (Min)</Form.Label>
							<Form.Control
								name="medical"
								type="number"
								value={props.formFields.medical}
								onChange={props.handleChange}
							/>
						</Form.Group>
					</Col>
					<Col>
						<Form.Group className="reimbursementPolicydropDown">
							<Form.Label>Medical (Parents)</Form.Label>
							<Form.Control
								name="medicalParent"
								type="number"
								value={props.formFields.medicalParent}
								onChange={props.handleChange}
							/>
						</Form.Group>
					</Col>
				</Row>
				<Row className="row2">
					<Col>
						<Form.Group className="reimbursementPolicydropDown">
							<Form.Label>Medical (Dental)</Form.Label>
							<Form.Control
								name="medicalDental"
								type="number"
								value={props.formFields.medicalDental}
								onChange={props.handleChange}
							/>
						</Form.Group>
					</Col>
					<Col>
						<Form.Group className="reimbursementPolicydropDown">
							<Form.Label>Internet</Form.Label>
							<Form.Control
								name="internet"
								type="number"
								value={props.formFields.internet}
								onChange={props.handleChange}
							/>
						</Form.Group>
					</Col>
				</Row>
				<Row className="row3">
					<Col>
						<Form.Group className="reimbursementPolicydropDown">
							<Form.Label>Fuel / Maintenance </Form.Label>
							<Form.Control
								name="fuel"
								type="number"
								value={props.formFields.fuel}
								onChange={props.handleChange}
							/>
						</Form.Group>
					</Col>
					<Col>
						<Form.Group className="reimbursementPolicydropDown">
							<Form.Label>Mobile [Old]</Form.Label>
							<Form.Control
								name="mobile"
								type="number"
								value={props.formFields.mobile}
								onChange={props.handleChange}
							/>
						</Form.Group>
					</Col>
				</Row>
				<Row className="row4">
					<Col>
						<Form.Group className="reimbursementPolicydropDown">
							<Form.Label>Health Club</Form.Label>
							<Form.Control
								name="healthClub"
								type="number"
								value={props.formFields.healthClub}
								onChange={props.handleChange}
							/>
						</Form.Group>
					</Col>
					<Col>
						<Form.Group className="reimbursementPolicydropDown">
							<Form.Label>WEF Date</Form.Label>
							<div className="policyDatePicker">
								<DatePicker
									showYearDropdown
									showMonthDropdown
									dateFormatCalendar=" " //for title
									className="custom-container"
									value={moment(props.wefDate).format(
										TableDateFormat
									)}
									onChange={props.wefDateChange}
									onChangeRaw={(e) => {
										e.preventDefault();
									}}
									autoComplete="off"
									dateFormat="dd/MM/yyyy"
								/>
								<FontAwesomeIcon
									icon={faCalendarAlt}
									className="calender-icon"
									color="keppel"
								/>
							</div>
						</Form.Group>
					</Col>
				</Row>
				<div className="btns">
					<Button
						className="submit-btn leftBtn"
						onClick={props.handleSubmit}
					>
						Submit
					</Button>
					<Button className="reset-btn" onClick={props.ResetForm}>
						Reset
					</Button>
				</div>
			</Form>
		</>
	);
};

export default ReimbursementPolicyForm;
